import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const VideogameFrameToDownload = (
  props: QRFRameToPrintProps
): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 7.999875 0.5 L 88.000125 0.5 C 92.142 0.5 95.500125 3.857839 95.500125 8 L 95.500125 120 C 95.500125 124.142161 92.142 127.5 88.000125 127.5 L 7.999875 127.5 C 3.858 127.5 0.499875 124.142161 0.499875 120 L 0.499875 8 C 0.499875 3.857839 3.858 0.5 7.999875 0.5 Z M 7.999875 0.5 "
          transform="matrix(10.416667,0,0,10.414062,0,0)"
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 629.808594 966.242188 L 629.808594 938.300781 L 359.773438 938.300781 L 359.773438 992.292969 L 539.445312 992.292969 C 554.683594 973.722656 578.253906 961.996094 604.839844 962.300781 C 613.519531 962.402344 621.90625 963.777344 629.808594 966.242188 Z M 629.808594 966.242188 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 534.832031 998.503906 C 528.414062 1008.078125 524.042969 1019.097656 522.304688 1030.992188 L 260.542969 1030.992188 L 260.542969 1018.027344 C 260.542969 1007.242188 269.28125 998.503906 280.066406 998.503906 Z M 534.832031 998.503906 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 161.691406 374.90625 L 827.894531 374.90625 C 836.648438 374.90625 843.75 382.007812 843.75 390.765625 L 843.75 916.371094 C 843.75 925.128906 836.648438 932.234375 827.894531 932.234375 L 161.691406 932.234375 C 152.933594 932.234375 145.832031 925.128906 145.832031 916.371094 L 145.832031 390.765625 C 145.832031 382.007812 152.933594 374.90625 161.691406 374.90625 Z M 178.371094 899.6875 L 811.214844 899.6875 L 811.214844 407.445312 L 178.371094 407.445312 Z M 178.371094 899.6875 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 851.753906 1062.558594 C 844.214844 1062.472656 838.039062 1056.601562 837.953125 1049.445312 C 837.867188 1042.292969 843.902344 1036.554688 851.441406 1036.640625 C 858.976562 1036.722656 865.152344 1042.59375 865.238281 1049.746094 C 865.324219 1056.902344 859.285156 1062.640625 851.753906 1062.558594 Z M 820.730469 1033.085938 C 813.195312 1033 807.019531 1027.132812 806.929688 1019.972656 C 806.84375 1012.816406 812.882812 1007.085938 820.421875 1007.167969 C 827.953125 1007.253906 834.132812 1013.121094 834.21875 1020.277344 C 834.304688 1027.4375 828.265625 1033.167969 820.730469 1033.085938 Z M 821.433594 1091.339844 C 813.898438 1091.257812 807.71875 1085.386719 807.632812 1078.230469 C 807.546875 1071.074219 813.585938 1065.335938 821.121094 1065.421875 C 828.65625 1065.503906 834.835938 1071.378906 834.917969 1078.53125 C 835.007812 1085.695312 828.96875 1091.425781 821.433594 1091.339844 Z M 790.414062 1061.871094 C 782.878906 1061.785156 776.699219 1055.921875 776.613281 1048.757812 C 776.527344 1041.605469 782.566406 1035.871094 790.101562 1035.957031 C 797.636719 1036.039062 803.8125 1041.90625 803.898438 1049.0625 C 803.988281 1056.226562 797.945312 1061.953125 790.414062 1061.871094 Z M 766.46875 1143.847656 C 750.757812 1143.671875 737.875 1131.4375 737.695312 1116.511719 C 737.515625 1101.589844 750.105469 1089.632812 765.820312 1089.8125 C 781.53125 1089.988281 794.414062 1102.222656 794.59375 1117.148438 C 794.773438 1132.070312 782.183594 1144.027344 766.46875 1143.847656 Z M 706.753906 1070.730469 C 696.277344 1070.617188 687.679688 1062.453125 687.5625 1052.507812 C 687.441406 1042.550781 695.84375 1034.574219 706.320312 1034.691406 C 716.800781 1034.808594 725.390625 1042.980469 725.511719 1052.925781 C 725.632812 1062.878906 717.234375 1070.855469 706.753906 1070.730469 Z M 674.53125 1121.28125 C 674.550781 1122.761719 673.300781 1123.949219 671.742188 1123.925781 L 649.15625 1123.675781 L 649.414062 1145.128906 C 649.433594 1146.609375 648.183594 1147.796875 646.625 1147.777344 L 634.628906 1147.640625 C 633.070312 1147.628906 631.792969 1146.410156 631.773438 1144.933594 L 631.515625 1123.480469 L 608.929688 1123.230469 C 607.371094 1123.207031 606.097656 1122 606.078125 1120.523438 L 605.941406 1109.128906 C 605.921875 1107.640625 607.171875 1106.464844 608.730469 1106.472656 L 631.3125 1106.722656 L 631.054688 1085.28125 C 631.039062 1083.800781 632.285156 1082.613281 633.847656 1082.636719 L 645.84375 1082.761719 C 647.402344 1082.78125 648.679688 1084 648.695312 1085.480469 L 648.953125 1106.921875 L 671.539062 1107.179688 C 673.097656 1107.191406 674.378906 1108.410156 674.394531 1109.890625 Z M 652.542969 1144.191406 L 652.332031 1126.699219 L 670.765625 1126.90625 C 667.515625 1134.839844 660.902344 1141.109375 652.542969 1144.191406 Z M 628.683594 1144.066406 C 620.058594 1140.851562 613.125 1134.363281 609.625 1126.230469 L 628.472656 1126.4375 Z M 627.980469 1085.6875 L 628.199219 1103.777344 L 609.179688 1103.558594 C 612.414062 1095.289062 619.269531 1088.769531 627.980469 1085.6875 Z M 562.804688 1043.542969 C 562.601562 1026.785156 576.742188 1013.363281 594.382812 1013.558594 C 612.019531 1013.757812 626.484375 1027.496094 626.6875 1044.25 C 626.886719 1061.003906 612.75 1074.429688 595.113281 1074.230469 C 577.472656 1074.035156 563.007812 1060.285156 562.804688 1043.542969 Z M 651.839844 1086.101562 C 660.4375 1089.425781 667.289062 1096.027344 670.667969 1104.246094 L 652.058594 1104.035156 Z M 895.605469 1184.257812 C 891.183594 1147.691406 891.167969 1147.546875 879.867188 1054.121094 C 875.269531 1013.519531 838.902344 981.402344 795.117188 980.917969 C 778.066406 980.726562 762.253906 985.363281 749.089844 993.488281 C 719.480469 1006.308594 692.867188 1006.011719 662.945312 992.527344 C 649.578125 984.109375 633.652344 979.117188 616.597656 978.925781 C 572.8125 978.441406 537.210938 1009.753906 533.589844 1050.269531 C 524.535156 1143.464844 524.523438 1143.609375 520.980469 1180.078125 C 520.875 1181.164062 520.820312 1182.257812 520.835938 1183.371094 C 521.042969 1200.636719 535.949219 1214.800781 554.125 1215 C 562.859375 1215.09375 570.757812 1211.945312 576.585938 1206.738281 C 596.371094 1189.058594 602.160156 1183.902344 629.246094 1159.6875 C 684.476562 1143.660156 731.191406 1144.183594 786.824219 1161.449219 C 814.5 1186.265625 820.40625 1191.554688 840.621094 1209.675781 C 846.578125 1215.019531 854.558594 1218.339844 863.292969 1218.445312 C 881.472656 1218.644531 896.039062 1204.8125 895.832031 1187.546875 C 895.816406 1186.441406 895.738281 1185.339844 895.605469 1184.257812 Z M 895.605469 1184.257812 "
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 177.082031 898.390625 L 809.929688 898.390625 L 809.929688 406.148438 L 177.082031 406.148438 Z M 177.082031 898.390625 "
        />
        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="500"
          y="290.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
